import { Component } from 'react';
import { DropdownFinalFormAdapter } from 'components/Dropdown/Dropdown';
import Field from 'components/Field/Field';
import Form from 'components/Form/Form';
import { InputFinalFormAdapter } from 'components/Input/Input';
import { maskYYYY, unmaskYYYY } from 'components/Input/masks';
import {
  SELECTOR_TYPES,
  SelectorFinalFormAdapter,
} from 'components/Selector/Selector';
import { YesNoFinalFormAdapter } from 'components/Selector/YesNoFinalFormAdapter/YesNoFinalFormAdapter';
import String from 'components/String/String';
import Space from 'corecomponents/Space/Space';
import { isEqual, isNil } from 'es-toolkit/compat';
import arrayMutators from 'final-form-arrays';
import { Col, Row } from 'forkedlibraries/react-bootstrap';
import Condition from 'formcomponents/Condition/Condition';
import FormLayout from 'layouts/FormLayout/FormLayout';
import PropTypes from 'prop-types';
import { HOMEOWNER_ONBOARDING_STRINGS } from 'strings/homeowner-onboarding.strings';
import {
  composeValidators,
  required,
  validPastYYYYString,
} from 'utils/validation';
import GreenInfoBox from '../../../../components/GreenInfoBox/GreenInfoBox';
import PropertyRentalLabel from '../components/PropertyRentalLabel/PropertyRentalLabel';
import styles from './UnitCondition.module.css';

const { FormLayoutHeader } = FormLayout;
const HOB = HOMEOWNER_ONBOARDING_STRINGS.UnitConditions;

const buttonLabels = [
  {
    name: 'Quite Rundown',
    enum: 'QuiteRundown',
  },
  {
    name: 'Needs Work',
    enum: 'NeedsWork',
  },
  {
    name: 'Quite Average',
    enum: 'QuiteAverage',
  },
  {
    name: 'Pretty Good',
    enum: 'PrettyGood',
  },
  {
    name: 'Shiny Palace',
    enum: 'ShinyPalace',
  },
];

class UnitCondition extends Component {
  static propTypes = {
    groups: PropTypes.object.isRequired,
    currentStepData: PropTypes.object.isRequired,
    currentStepResources: PropTypes.object.isRequired,
    onSaveAndNext: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
  };

  onSubmit = async (values) => {
    const { onSaveAndNext } = this.props;

    if (values.renovatedHomeBefore === false) {
      values.lastRenovation = 0;
    }

    onSaveAndNext(values);
  };

  getInitialValues() {
    return {
      ...this.props.currentStepData,
      unitConditions: {
        ...this.props.currentStepData?.unitConditions,
        renovatedHomeBefore: !isNil(
          this.props.currentStepData?.unitConditions?.condition,
        )
          ? !!this.props.currentStepData?.unitConditions?.lastRenovation
          : null,
      },
    };
  }

  render() {
    const { groups, currentStepResources, onBack } = this.props;

    if (!groups || !currentStepResources || !onBack) {
      return null;
    }

    const { homes } = groups;
    const { property, home } = currentStepResources;

    return (
      <>
        {homes?.length > 1 && (
          <PropertyRentalLabel property={property} home={home} />
        )}
        <FormLayoutHeader pretitle={HOB.subtitle} title={HOB.title} />

        <Form
          mutators={{
            ...arrayMutators,
          }}
          getFormBottomBar={(formProps, nextButtonProps) => (
            <FormLayout.BottomBar
              ctaProps={{
                label: 'Next',
                type: 'submit',
              }}
              nextButtonWrapperProps={nextButtonProps}
              previousStepProps={{
                onClick: onBack,
                to: null,
              }}
            />
          )}
          initialValuesEqual={(values1, values2) => isEqual(values1, values2)}
          initialValues={this.getInitialValues()}
          onSubmit={this.onSubmit}
          getForm={() => (
            <>
              <FormLayout.Section>
                <Field
                  name="unitConditions.condition"
                  component={SelectorFinalFormAdapter}
                  validate={required}
                  buttons={[
                    {
                      label: buttonLabels[0].name,
                      key: buttonLabels[0].enum,
                    },
                    {
                      label: buttonLabels[1].name,
                      key: buttonLabels[1].enum,
                    },
                    {
                      label: buttonLabels[2].name,
                      key: buttonLabels[2].enum,
                    },
                    {
                      label: buttonLabels[3].name,
                      key: buttonLabels[3].enum,
                    },
                    {
                      label: buttonLabels[4].name,
                      key: buttonLabels[4].enum,
                    },
                  ]}
                  type={SELECTOR_TYPES.SMALLTEXTBUTTON}
                  fluid
                />
                <Row>
                  <Col md={6}>
                    <Field
                      name="unitConditions.appliancesAge"
                      component={DropdownFinalFormAdapter}
                      placeholder={HOB.applianceAverageAge}
                      items={[
                        { value: 'Older', key: 'Older' },
                        { value: 'Recently Updated', key: 'RecentlyUpdated' },
                        { value: 'Brand New', key: 'BrandNew' },
                      ]}
                      validate={required}
                    />
                  </Col>
                </Row>
              </FormLayout.Section>
              <FormLayout.Section sectionTitle={HOB.renovatedThisHome}>
                <Row>
                  <Col md={6}>
                    <Field
                      name="unitConditions.renovatedHomeBefore"
                      component={YesNoFinalFormAdapter}
                      validate={required}
                      fluid
                      className={styles['yes-no-selector']}
                    />
                  </Col>
                </Row>
                <Condition when="unitConditions.renovatedHomeBefore" is>
                  <Row>
                    <Col md={6}>
                      <Field
                        placeholder={HOB.lastRenovationDate}
                        name="unitConditions.lastRenovation"
                        component={InputFinalFormAdapter}
                        mask={maskYYYY}
                        unmask={unmaskYYYY}
                        validate={composeValidators(
                          required,
                          validPastYYYYString,
                        )}
                      />
                    </Col>
                  </Row>
                </Condition>
              </FormLayout.Section>
              <FormLayout.Section sectionTitle={HOB.isHomeCurrentlyFurnished}>
                <Row>
                  <Col md={6}>
                    <Field
                      fluid
                      type={SELECTOR_TYPES.SMALLTEXTBUTTONWIDTH}
                      name="unitFurnishing.isFurnished"
                      component={SelectorFinalFormAdapter}
                      buttons={HOB.isHomeCurrentlyFurnishedButtons}
                      validate={required}
                      className={styles['yes-no-selector']}
                    />
                  </Col>
                </Row>
                <Condition when="unitFurnishing.isFurnished" is>
                  <Space />

                  <GreenInfoBox>
                    <String string={HOB.homeCurrentlyFinishedText} />
                  </GreenInfoBox>
                </Condition>
              </FormLayout.Section>
              <Condition when="unitFurnishing.isFurnished" is>
                <FormLayout.Section
                  sectionTitle={HOB.rentingYourHomeUnfurnished}
                >
                  <Row>
                    <Col md={6}>
                      <Field
                        name="unitFurnishing.isUserWillingToRentHomeUnfurnished"
                        component={YesNoFinalFormAdapter}
                        validate={required}
                        fluid
                        className={styles['yes-no-selector']}
                      />
                    </Col>
                  </Row>
                </FormLayout.Section>
              </Condition>
            </>
          )}
        />
      </>
    );
  }
}

export default UnitCondition;
